<section class="oe-card">
  <div class="oe-header">
    <h2 class="oe-title">Upcoming Open Enrollments</h2>
    <div *ngIf="hasImminent" class="needs-action-label">Needs action</div>
  </div>

  <div class="oe-scroll">
    <div *ngIf="loading" class="flex items-center justify-center py-10">
      <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
    </div>

    <p *ngIf="!loading && items.length === 0" class="oe-empty">
      {{ emptyMessage }}
    </p>

    <ul *ngIf="!loading && items.length > 0" class="oe-list">
      <ng-container *ngFor="let item of items; let i = index">
        <li *ngIf="isGroupDivider(i)" class="oe-divider">Next upcoming periods</li>
        <li class="oe-row" [class.oe-row--after-divider]="isGroupDivider(i)">
          <span class="days-badge" [class.days-badge--later]="item.daysUntilOpen > 7">{{ daysLabel(item.daysUntilOpen) }}</span>
          <div class="oe-body">
            <div class="client-name">{{ item.clientName }}</div>
            <div class="oe-meta">OE opens {{ openDate(item.openDate) | date:'MMM d, y' }}</div>
          </div>
          <a class="view-link" [routerLink]="['/clients', item.mCode, 'subclients', item.cCode, 'enrollment-settings']">View</a>
        </li>
      </ng-container>
    </ul>
  </div>

  <p *ngIf="summary" class="oe-caption">{{ summary }}</p>
</section>
